<template>
  <div>
    <vue-headful
      title = '白金科技股份有限公司-產品與服務'
      url = 'http://www.ptotinc.com/#/products'
    />
    <div id="banner">
      <div class="slider-pro sp-horizontal" id="example1" style="width: 100%; max-width: 5200px">
        <div class="sp-slides">
          
           <!--
          <div class="sp-slide">
            <a href="javascript:void(1)"><img
                class="sp-image"
                src="~@/assets/15002842221.jpg"
                alt=""
                title="" /></a>
          </div>
          -->
          <div class="sp-slide">
            <a href="javascript:void(1)"><img
                class="sp-image"
                src="~@/assets/15011452161.png"
                alt=""
                title=""/></a>
          </div>
        </div>
      </div>
    </div>
    <div id="wrap_c">
      <div class="breadCrumb">
        <a href="/" tabindex="101" class="breadCrumb_no" title="首頁">首頁</a>
        <router-link :to="{name:'產品與服務'}"><span>產品與服務</span></router-link> 
      </div>
      <div class="cC">
        <h2 class="titleA">產品與服務</h2>

        <div class="info_content">
          <!-- <link href="~@/assets/css/edit_temp1_3.css" rel="stylesheet" type="text/css" /> -->
          <!-- 單欄式3 -->
          <div id="edit_temp1_3">
            <div class="edit_c"><img
                src="~@/assets/15203007741.jpg"
                style="width: 414px; height: 276px;" />
              <h2><strong>紅外吸收式濾片(藍玻璃)<br />
                  IR absorbing filter</strong></h2>

              <h3>&nbsp;</h3>

              <p>本產品主要的功用是改善色偏及眩光問題，其運作原理主要是經由吸收紅外光，減少CMOS
                sensor感應到的紅外光強度，讓屏幕上的色彩呈現更自然，更接近人眼的色彩感受。目前已經廣泛運用在智慧型手機，單反相機及無人機等各類需要攝像頭模組，且對影像呈現品質有要求的消費性電子產品。</p>
            </div>

            <div class="edit_c"><img
                src="~@/assets/15203136511.jpg"
                style="width: 414px; height: 276px;" />
              <h2><strong>光學低通濾波片<br />
                  Optical Low Pass Filter</strong></h2>

              <h3>&nbsp;</h3>

              <p>利用石英雙折射晶體的分光性質來實現低通濾波，目前主要應用在數位相機，安防監控產品，PC cam 及IR cam等產品。</p>
            </div>

            <div class="edit_c"><img
                src="~@/assets/15203070371.jpg"
                style="width: 414px; height: 276px;" />
              <h2><strong>視覺模擬濾光片<br />
                  Vision lambda filter (X,Y,Z filter)</strong></h2>

              <h3>&nbsp;</h3>

              <p>採用吸收式玻璃基材，主要功用是模擬人眼的視覺運作方式，能針對R/G/B三色做色域分離，進而可對三原色做高精度光學檢測。</p>
            </div>

            <div class="edit_c"><img
                src="~@/assets/15203083561.jpg"
                style="width: 414px; height: 276px;" />
              <h2><strong>紅外光穿透濾光片<br />
                  IR Band Pass filter</strong></h2>

              <h3>&nbsp;</h3>

              <p>白金是業界少數幾家能夠提供符合3D模組濾片規格要求的廠商，目前的結構光或是ToF模組，都需要搭配紅外窄帶濾片(IR band pass filter)，其中有三大重點特性：1. Low Angle
                Shift 2.光譜截止區做到超低穿透, 也就是High OD(Optical Density), 能有效抑制可見光源 3. Particle
                control。只有把這三項做到極致，濾片才能幫助整個模組精準地做到深度偵測(depth sensing)的要求，捕抓到3D建模所需要的資料。</p>
            </div>

            <div class="edit_c"><img
                src="~@/assets/15203089231.jpg"
                style="width: 414px; height: 276px;" />
              <h2><strong>高折射玻璃<br />
                  High Refraction Index Glass</strong></h2>

              <h3>&nbsp;</h3>

              <p>白金提供各式客製化高折射玻璃。</p>
            </div>

            <div class="edit_c"><img
                src="~@/assets/15204192731.jpg"
                style="width: 414px; height: 276px;" />
              <h2><strong>螢光玻璃片<br />
                  Phosphor in glass</strong></h2>

              <h3>&nbsp;</h3>

              <p>應用於LED封裝，使用無機材料製作而成的螢光玻璃片，可承載150℃以上的高溫，可解決矽膠封裝無法避免的高溫老化及黃化問題，適合應用在車燈或是常態高溫之應用。<br />
                <br />
                詳情規格請來信詢問 Contact window: <a href="mailto:kyle.wu@ptotinc.com">
                  <font color="#0066cc">kyle.wu@ptotinc.com</font>
                </a></p>
            </div>

            <div class="edit_c"><img
                src="~@/assets/15203142241.jpg"
                style="width: 414px; height: 276px;" />
              <h2><strong>玻璃粉<br />
                  Glass Frit/Glass Powder</strong></h2>

              <h3>&nbsp;</h3>

              <p>可應用於高溫燒結膠材，如太陽能導電銀膠/鋁膠、被動元件保護膠或端電極膠、LED導電膠、Touch Panel導電膠...等。<br />
                <br />
                詳情規格請來信詢問 Contact window: <a href="mailto:kyle.wu@ptotinc.com">kyle.wu@ptotinc.com</a></p>
            </div>

            <div class="edit_c">
            <img src="~@/assets/DSC00066-S.jpg" style="width: 414px; height: 276px;" />
              <h2><strong>玻璃擴散片<br />
                  Diffuser</strong></h2>

              <p>玻璃擴散片的優點如下:<br />
                ● 半透明的白玻璃基材可以讓光更均勻地擴散<br />
                ● 固態擴散物質, 使其可以運用到任何方向<br />
                ● 高度光學一致性, 優秀的品質穩定性<br />
                ● 兩面皆有光學擴散效用, 透射的光線具有近朗勃特性 (near-Lambertian)<br />
                ● 極佳的光擴散效果<br />
                ● 可耐高溫,可靠性更佳</p>
            </div>

            <div class="edit_c">
            <img src="~@/assets/Isolumina.jpg" style="width: 414px; height: 276px; margin-bottom: 160px;" />
              <h2><strong>高穿透氧化鋁基板<br />
                  ISOLUMINA™</strong></h2>
              <p>
              透明載體晶圓, 可供製程中暫時貼合便於晶圓加工<br />
              兼具均向熱穩定性與高透光率的氧化鋁基板<br />
              專為高階 COPOS 及 先進扇出型封裝製程打造<br />
              </p>

              <p>Properties:<br />
                ● Transmittance: >74% @365~1100nm<br />
                ● CTE: 7.7x10<sup>-6</sup>@25℃<br />
                ● Young’s Modulus: 400GPa<br />
                ● Bending Strength: 650MPa<br />
                ● Substrate Thickness: Standard 1.0mm (Customizable)<br />
                ● Substrate Dimension: Up to Ø300mm (Customizable)<br />
                詳情規格請來信詢問 Contact window: <a href="mailto:kyle.wu@ptotinc.com">kyle.wu@ptotinc.com</a>
                </p>
            </div>
          </div>

          <div id="edit_temp1_2">&nbsp;</div>

          <div id="edit_temp1_3">
            <div id="edit_temp1_3">
              <div id="edit_temp1_3">
                <div id="edit_temp1_3">
                  <div id="edit_temp1_3">
                    <div id="edit_temp1_3">
                      <div id="edit_temp1_3">
                        <div id="edit_temp1_3">
                          <div id="edit_temp1_3">
                            <div id="edit_temp1_3">
                              <div id="edit_temp1_3">&nbsp;</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'products',
  // metaInfo() {
  //   return {
  //     title: `白金科技股份有限公司-產品與服務`,
  //     meta: [
  //       { property: 'og:title', content: '白金科技股份有限公司-產品與服務'},
  //       {property: 'og:url', content: 'http://www.ptotinc.com/products' },
  //     ]
  //   }
  // },
  data () {
    return {
      isAboutPage: false,
      isProductPage: true
    }
  },
  created: function () {
    console.log('created')
  },
  mounted: function () {
    console.log('moundted')
    this.init()
    this.$emit('setCurrentMenu', 'about'); // about/ product/ recruit/ contactus
  },
  methods: {
    init: function () {
      $('#rwd_nav').pageslide({
          modal: true
      });
      animate();
      $('.sp-selected .sp-font span').addClass('animated fadeInLeft');
      $('.sp-selected .sp-font2').addClass('animated fadeInRight');
      $('#example1').sliderPro({
          keyboardOnlyOnFocus: true,
          set_swipe: '1',
          width: '5120',
          height: '1280',
          autoplay: true,
          waitForLayers: true,
          autoScaleLayers: false,
          fade: true,
          autoplayDelay: 5000,
          arrows: false,
          buttons: false,
          breakpoints: {
            1024: {
              forceSize: '',
              width: '1024',
              height: '256'
            }
          }
      });
      sliderPro_add_title('default', "%%%%%%%%%@@@%%%%%%%%%@@@", "%%%%%%%%%@@@%%%%%%%%%@@@");
      // initVideo();
    }
  }
}
</script>
<style src='@/assets/css/edit_temp.css'></style>
<style src='@/assets/css/15347449502.css'></style>


// WEBPACK FOOTER //
// src/components/product/Products.vue